<template>
  <div :class="{'show-more': true, 'show-more-collapse': collapse}">
    <div class="show-more-content" :style="collapse ? 'max-height:' + showheight + ';' : ''">
      <slot></slot>
    </div>
    <el-button @click="collapse=!collapse" type="text" size="small">{{collapse ? '加载更多...' : '隐藏'}}</el-button>
  </div>
</template>

<script>
export default {
  name: 'ShowMore',
  props: {
    showheight: String
  },
  data () {
    return {
      collapse: true
    }
  }
}
</script>

<style lang="scss">
.show-more-collapse {
  .show-more-content{
    overflow: hidden;
  }
}
</style>